import { render, staticRenderFns } from "./CampaignButtonAcceptAsPublisher.vue?vue&type=template&id=3a13ad5e&"
import script from "./CampaignButtonAcceptAsPublisher.vue?vue&type=script&lang=js&"
export * from "./CampaignButtonAcceptAsPublisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports